import { PaginationContainer } from './styled-components.js'
import PaginationLeft from './components/pagination-left.jsx'
import PaginationCenter from './components/pagination-center.jsx'
import PaginationRight from './components/pagination-right.jsx'

export const PaginationComponent = ({ pagination, selectedItems = null }) => {
  return (
    <PaginationContainer>
      <PaginationLeft
        pageNumber={pagination.pageNumber}
        totalElements={pagination.totalElements}
        pageSize={pagination.pageSize}
      />
      <PaginationCenter
        pageNumber={pagination.pageNumber}
        totalElements={pagination.totalElements}
        totalPages={pagination.totalPages}
        onPageChange={pagination.onPageChange}
      />
      <PaginationRight selectedItems={selectedItems} />
    </PaginationContainer>
  )
}

export default PaginationComponent
